module.exports = __webpack_public_path__ + "img/promo-full-light.svg";